import type { BuiltInGlobalTheme } from './interface'
import { scrollbarDark } from '../_internal/scrollbar/styles'
import { commonDark } from '../_styles/common'
import { alertDark } from '../alert/styles'
import { anchorDark } from '../anchor/styles'
import { autoCompleteDark } from '../auto-complete/styles'
import { avatarGroupDark } from '../avatar-group/styles'
import { avatarDark } from '../avatar/styles'
import { backTopDark } from '../back-top/styles'
import { badgeDark } from '../badge/styles'
import { breadcrumbDark } from '../breadcrumb/styles'
import { buttonGroupDark } from '../button-group/styles'
import { buttonDark } from '../button/styles'
import { calendarDark } from '../calendar/styles'
import { cardDark } from '../card/styles'
import { carouselDark } from '../carousel/styles'
import { cascaderDark } from '../cascader/styles'
import { checkboxDark } from '../checkbox/styles'
import { codeDark } from '../code/styles'
import { collapseTransitionDark } from '../collapse-transition/styles'
import { collapseDark } from '../collapse/styles'
import { colorPickerDark } from '../color-picker/styles'
import { dataTableDark } from '../data-table/styles'
import { datePickerDark } from '../date-picker/styles'
import { descriptionsDark } from '../descriptions/styles'
import { dialogDark } from '../dialog/styles'
import { dividerDark } from '../divider/styles'
import { drawerDark } from '../drawer/styles'
import { dropdownDark } from '../dropdown/styles'
import { dynamicInputDark } from '../dynamic-input/styles'
import { dynamicTagsDark } from '../dynamic-tags/styles'
import { elementDark } from '../element/styles'
import { ellipsisDark } from '../ellipsis/styles'
import { emptyDark } from '../empty/styles'
import { equationDark } from '../equation/styles'
import { floatButtonGroupDark } from '../float-button-group/styles'
import { floatButtonDark } from '../float-button/styles'
import { formDark } from '../form/styles'
import { gradientTextDark } from '../gradient-text/styles'
import { heatmapDark } from '../heatmap/styles'
import { iconWrapperDark } from '../icon-wrapper/styles'
import { iconDark } from '../icon/styles'
import { imageDark } from '../image/styles'
import { inputNumberDark } from '../input-number/styles'
import { inputDark } from '../input/styles'
import { layoutDark } from '../layout/styles'
import { rowDark } from '../legacy-grid/styles'
import { legacyTransferDark } from '../legacy-transfer/styles'
import { listDark } from '../list/styles'
import { loadingBarDark } from '../loading-bar/styles'
import { logDark } from '../log/styles'
import { marqueeDark } from '../marquee/styles'
import { mentionDark } from '../mention/styles'
import { menuDark } from '../menu/styles'
import { messageDark } from '../message/styles'
import { modalDark } from '../modal/styles'
import { notificationDark } from '../notification/styles'
import { pageHeaderDark } from '../page-header/styles'
import { paginationDark } from '../pagination/styles'
import { popconfirmDark } from '../popconfirm/styles'
import { popoverDark } from '../popover/styles'
import { popselectDark } from '../popselect/styles'
import { progressDark } from '../progress/styles'
import { qrcodeDark } from '../qr-code/styles'
import { radioDark } from '../radio/styles'
import { rateDark } from '../rate/styles'
import { resultDark } from '../result/styles'
import { selectDark } from '../select/styles'
import { skeletonDark } from '../skeleton/styles'
import { sliderDark } from '../slider/styles'
import { spaceDark } from '../space/styles'
import { spinDark } from '../spin/styles'
import { splitDark } from '../split/styles'
import { statisticDark } from '../statistic/styles'
import { stepsDark } from '../steps/styles'
import { flexDark, inputOtpDark } from '../styles'
import { switchDark } from '../switch/styles'
import { tableDark } from '../table/styles'
import { tabsDark } from '../tabs/styles'
import { tagDark } from '../tag/styles'
import { thingDark } from '../thing/styles'
import { timePickerDark } from '../time-picker/styles'
import { timelineDark } from '../timeline/styles'
import { tooltipDark } from '../tooltip/styles'
import { transferDark } from '../transfer/styles'
import { treeSelectDark } from '../tree-select/styles'
import { treeDark } from '../tree/styles'
import { typographyDark } from '../typography/styles'
import { uploadDark } from '../upload/styles'
import { watermarkDark } from '../watermark/styles'

export const darkTheme: BuiltInGlobalTheme = {
  name: 'dark',
  common: commonDark,
  Alert: alertDark,
  Anchor: anchorDark,
  AutoComplete: autoCompleteDark,
  Avatar: avatarDark,
  AvatarGroup: avatarGroupDark,
  BackTop: backTopDark,
  Badge: badgeDark,
  Breadcrumb: breadcrumbDark,
  Button: buttonDark,
  ButtonGroup: buttonGroupDark,
  Calendar: calendarDark,
  Card: cardDark,
  Carousel: carouselDark,
  Cascader: cascaderDark,
  Checkbox: checkboxDark,
  Code: codeDark,
  Collapse: collapseDark,
  CollapseTransition: collapseTransitionDark,
  ColorPicker: colorPickerDark,
  DataTable: dataTableDark,
  DatePicker: datePickerDark,
  Descriptions: descriptionsDark,
  Dialog: dialogDark,
  Divider: dividerDark,
  Drawer: drawerDark,
  Dropdown: dropdownDark,
  DynamicInput: dynamicInputDark,
  DynamicTags: dynamicTagsDark,
  Element: elementDark,
  Empty: emptyDark,
  Ellipsis: ellipsisDark,
  Equation: equationDark,
  Flex: flexDark,
  Form: formDark,
  GradientText: gradientTextDark,
  Heatmap: heatmapDark,
  Icon: iconDark,
  IconWrapper: iconWrapperDark,
  Image: imageDark,
  Input: inputDark,
  InputNumber: inputNumberDark,
  InputOtp: inputOtpDark,
  LegacyTransfer: legacyTransferDark,
  Layout: layoutDark,
  List: listDark,
  LoadingBar: loadingBarDark,
  Log: logDark,
  Menu: menuDark,
  Mention: mentionDark,
  Message: messageDark,
  Modal: modalDark,
  Notification: notificationDark,
  PageHeader: pageHeaderDark,
  Pagination: paginationDark,
  Popconfirm: popconfirmDark,
  Popover: popoverDark,
  Popselect: popselectDark,
  Progress: progressDark,
  QrCode: qrcodeDark,
  Radio: radioDark,
  Rate: rateDark,
  Result: resultDark,
  Row: rowDark,
  Scrollbar: scrollbarDark,
  Select: selectDark,
  Skeleton: skeletonDark,
  Slider: sliderDark,
  Space: spaceDark,
  Spin: spinDark,
  Statistic: statisticDark,
  Steps: stepsDark,
  Switch: switchDark,
  Table: tableDark,
  Tabs: tabsDark,
  Tag: tagDark,
  Thing: thingDark,
  TimePicker: timePickerDark,
  Timeline: timelineDark,
  Tooltip: tooltipDark,
  Transfer: transferDark,
  Tree: treeDark,
  TreeSelect: treeSelectDark,
  Typography: typographyDark,
  Upload: uploadDark,
  Watermark: watermarkDark,
  Split: splitDark,
  FloatButton: floatButtonDark,
  FloatButtonGroup: floatButtonGroupDark,
  Marquee: marqueeDark
}
